__turbopack_context__.v({
  "expandingShape1": "Loading-module___6hnHG__expandingShape1",
  "expandingShape2": "Loading-module___6hnHG__expandingShape2",
  "fullscreen": "Loading-module___6hnHG__fullscreen",
  "mainShape": "Loading-module___6hnHG__mainShape",
  "rotateWithPause": "Loading-module___6hnHG__rotateWithPause",
  "shape1": "Loading-module___6hnHG__shape1",
  "shape2": "Loading-module___6hnHG__shape2",
});
